export default "__VITE_ASSET__796c8c72__"